import { LegendItemProps } from '../../utils/types'

export const LegendItem = ({ color, label, onClick }: LegendItemProps) => {
  return (
    <div
      className="flex items-center gap-2 cursor-pointer select-none"
      onClick={onClick}
    >
      <span
        className="w-3 h-3 rounded-full inline-block"
        style={{ backgroundColor: color }}
      />
      <span className="text-sm text-gray-700">{label}</span>
    </div>
  )
}
